var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrigger = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.25 0C22.8358 0 22.5 0.335787 22.5 0.750001V21.75C22.5 22.1642 22.8358 22.5 23.25 22.5C23.6642 22.5 24 22.1642 24 21.75V0.75C24 0.335786 23.6642 0 23.25 0ZM21.6796 3.46851C21.3043 3.29349 20.8579 3.45576 20.6825 3.83095L12.428 21.4949C12.2526 21.8701 12.4148 22.3161 12.7901 22.4912C13.1654 22.6662 13.6118 22.5039 13.7871 22.1287L22.0417 4.46476C22.2171 4.08957 22.0549 3.64353 21.6796 3.46851ZM17.4694 6.52945C17.7624 6.23704 18.2373 6.23729 18.53 6.53001C18.8227 6.82273 18.8225 7.29707 18.5294 7.58948L3.66369 22.4234C3.37065 22.7158 2.89581 22.7156 2.60309 22.4229C2.31037 22.1302 2.31062 21.6558 2.60366 21.3634L17.4694 6.52945ZM1.4809 1.48117C1.77379 1.18828 2.24867 1.18828 2.54156 1.48117L9 7.93961V3.74998C9 3.33576 9.33579 2.99998 9.75 2.99998C10.1642 2.99998 10.5 3.33576 10.5 3.74998V9.74998C10.5 10.1642 10.1642 10.5 9.75 10.5H3.75C3.33579 10.5 3 10.1642 3 9.74998C3 9.33576 3.33579 8.99998 3.75 8.99998H7.93904L1.4809 2.54183C1.18801 2.24894 1.18801 1.77407 1.4809 1.48117Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrigger);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trigger.b3c54b73399736652d2c7af05871a4c8.svg";